import { authenticatedAxios } from '../../utils/axios'
import CONSTANTS from '../../utils/constants'
import ENDPOINTS from '../constant'
import { updateCssVariables } from '../../utils/utils'
import { defaultPaltelTheme } from '../../assets/themes'
export const getPaltelCustomerInfoApi = async () => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getFixedLineCustomerInfo}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
      let name = localStorage.setItem(
        'name',
        JSON.stringify(res.data.result.name)
      )
      if (name !== '' && name !== null) {
        localStorage.setItem('name', JSON.stringify(res.data.result.name))
      } else {
        localStorage.setItem('name', 'customer name')
      }

      if(JSON.parse(localStorage.getItem('isPaltelCustomer'))){
        if(res.data.result.jawwalCorpAuthorized){
          localStorage.setItem('clickedLogin','Jawwal')
        } else if(res.data.result.isPaltelCorpAuthorized){
          localStorage.setItem('clickedLogin','Paltel')
        }
      }

      let localTheme =
        res.data.result.theme.code === 'Theme1'
          ? defaultPaltelTheme
          : defaultPaltelTheme

      res.data.result.theme.lightMode = {
        ...localTheme.lightMode,
        ...res.data.result.theme.lightMode,
      }
      res.data.result.theme.darkMode = {
        ...localTheme.darkMode,
        ...res.data.result.theme.darkMode,
      }

      if (
        !localStorage.getItem('themeName') ||
        localStorage.getItem('themeName') !== res.data.result.theme.code
      ) {
        localStorage.setItem(
          'light',
          JSON.stringify(res.data.result.theme.lightMode)
        )
        localStorage.setItem(
          'dark',
          JSON.stringify(res.data.result.theme.darkMode)
        )
        updateCssVariables(res.data.result.theme.lightMode)
        localStorage.setItem('themeName', res.data.result.theme.code)
      }
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error'
  }
  return responseData
}
export const getFixedLineRemainingMinutes = async () => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.usage.root}${ENDPOINTS.usage.getFixedLineRemainingMinutes}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'There is no remaning mins '
  }
  return responseData
}
export const getFixedLineHotOffers = async () => {
  let responseData = { hotOffers: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.offers.root}${ENDPOINTS.offers.getFixedLineHotOffers}`
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.hotOffers = res.data.result
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'Error while getting home offers'
  }
  return responseData
}
export const getFixedLineAllOffers = async (option) => {
  let responseData = { allOffers: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.offers.root}${ENDPOINTS.offers.getFixedLineHotOffers}`,
      {
        option: option,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.allOffers = res.data.result
    } else {
      responseData.error = res.responseMessage
    }
  } catch {
    responseData.error = 'Error while getting all offers'
  }
  return responseData
}
export const getFixedLinePlanDetails = async (data) => {
  let responseData = { planDetails: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getFixedLinePlanDetails}`,
      data
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.planDetails = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'Error while getting plan details'
  }
  return responseData
}
export const getFixedLineInvoicePDF = async (invoiceNo) => {
  let responseData = {
    pdfUrl: '',
    isSuccess: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.fixedlineGetBillPDF}?invoiceNo=${invoiceNo}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.pdfUrl = res.data.result
    }else{
      responseData.error = res.data.responseMessage
    }
    
  } catch (error) {
    responseData.error = 'General error while downloading the PDF'
  }
  return responseData
}
export const getFixedLineServiceInfoFromAPI = async () => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getServices}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Services'
  }
  return responseData
}

export const getOpenFLInvoicesfromAPI = async () => {
  let responseData = {
    bills: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getOpenFLInvoices}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.bills = res.data.result.bills
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.bills = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Fixed line Invoices'
  }
  return responseData
}
export const getFixedLineInstallmentsDetailsfromAPI = async () => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getInstallments}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result.installments
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Fixed line installment details'
  }
  return responseData
}